import { LuTicket, LuGift, LuGraduationCap, LuSparkles } from "react-icons/lu";
import { colors } from "../../../styles/theme/tokens";

// Іконка та кольори картки залежно від типу товару
export const KIND_STYLES = {
  discount: { Icon: LuTicket, tint: colors.amberSoft, color: colors.amberDeep },
  gift_friend: { Icon: LuGift, tint: colors.pinkSoft, color: colors.pink },
  free_lesson: { Icon: LuGraduationCap, tint: colors.brandSoft, color: colors.brandDeep },
  other: { Icon: LuSparkles, tint: colors.brandSoft, color: colors.brand },
};
